import axios from 'axios';
import AjaxResponseInterface from '@/interfaces/AjaxResponseInterface';
import SalutationInterface from '@/interfaces/SalutationInterface';
import BillingTypeInterface from '@/interfaces/BillingTypeInterface';
import DateConfig from '@/interfaces/order/DateConfig';

class IoOrderAPI {
  static getSalutations(): Promise<{
    private: SalutationInterface[],
    business: SalutationInterface[],
  }> {
    return new Promise((resolve, reject) => {
      axios.get<{
        private: SalutationInterface[],
        business: SalutationInterface[],
      }>(`${window.ioappConfig.restAPIUrl}io-order`, {
        params: {
          endpoint: 'getSalutations',
        },
      }).then((response) => {
        const ajaxResponse = response.data as unknown as AjaxResponseInterface;
        const ajaxResponseData = ajaxResponse.data as Record<string, unknown>;

        resolve(ajaxResponseData.salutations as {
          private: SalutationInterface[],
          business: SalutationInterface[],
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static getBillingTypes(): Promise<BillingTypeInterface[]> {
    return new Promise((resolve, reject) => {
      axios.get<BillingTypeInterface[]>(`${window.ioappConfig.restAPIUrl}io-order`, {
        params: {
          endpoint: 'getBillingTypes',
        },
      }).then((response) => {
        const ajaxResponse = response.data as unknown as AjaxResponseInterface;
        const ajaxResponseData = ajaxResponse.data as Record<string, unknown>;

        resolve(ajaxResponseData.billingTypes as BillingTypeInterface[]);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static getDateConfig(): Promise<{
    moving: DateConfig,
    supplierChange: DateConfig,
  }> {
    return new Promise((resolve, reject) => {
      axios.get<{
        moving: DateConfig,
        supplierChange: DateConfig,
      }>(`${window.ioappConfig.restAPIUrl}io-order`, {
        params: {
          endpoint: 'getDateConfig',
        },
      }).then((response) => {
        const ajaxResponse = response.data as unknown as AjaxResponseInterface;
        const ajaxResponseData = ajaxResponse.data as Record<string, unknown>;

        resolve(ajaxResponseData.dateConfig as {
          moving: DateConfig,
          supplierChange: DateConfig,
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default IoOrderAPI;
